// extracted by mini-css-extract-plugin
export default {"transition-effect":"Transition_transition-effect__1+oJR"};